var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-header"}),_c('div',{staticClass:"content-container"},[_c('BudgetGridInfo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }